var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIc21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "11.9272mm",
    height: "9.8795mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 297.32 246.28",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1993342894320"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    fillRule: "nonzero",
    d: "M45.7 246.28c-0.01,-0 -0.04,-0 -0.06,-0 -25.2,0 -45.64,-20.44 -45.64,-45.64 0,-25.2 20.44,-45.64 45.64,-45.64 25.2,0 45.64,20.44 45.64,45.64 0,0.02 0,0.05 0,0.07 -0.03,25.15 -20.42,45.54 -45.57,45.57l-0 0zm0 -85.74c-22.14,-0 -40.1,17.95 -40.1,40.1 0,22.14 17.96,40.1 40.1,40.1 22.12,0 40.07,-17.92 40.1,-40.04 -0.03,-22.13 -17.97,-40.07 -40.1,-40.1l-0 -0.06z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M148.66 246.28c-25.2,-0 -45.64,-20.44 -45.64,-45.65 0,-25.2 20.44,-45.64 45.64,-45.64 25.2,0 45.64,20.44 45.64,45.64 0,0.02 0,0.05 0,0.07 -0.03,25.18 -20.46,45.57 -45.64,45.57 0,0 0,0 0,0l-0 0zm0 -85.74c-22.14,-0 -40.1,17.95 -40.1,40.1 0,22.14 17.96,40.1 40.1,40.1 22.14,0 40.1,-17.96 40.1,-40.1 -0.03,-22.12 -17.98,-40.04 -40.1,-40.04 0,0 0,0 0,0l-0 -0.06z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1993342893120"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    fillRule: "nonzero",
    d: "M251.68 246.28c-25.2,-0 -45.64,-20.44 -45.64,-45.65 0,-25.2 20.44,-45.64 45.64,-45.64 25.2,0 45.64,20.44 45.64,45.64 0,0.02 0,0.05 0,0.07 -0.07,25.16 -20.48,45.54 -45.64,45.57l0 0zm0 -85.74c-0.02,-0 -0.05,-0 -0.07,-0 -22.14,0 -40.1,17.96 -40.1,40.1 0,22.14 17.96,40.1 40.1,40.1 22.14,0 40.1,-17.96 40.1,-40.1 -0.03,-22.09 -17.94,-40 -40.04,-40.04l0 -0.06z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M215.27 66.62c0,-36.79 -29.82,-66.62 -66.62,-66.62 -36.79,0 -66.61,29.82 -66.61,66.62 0,36.79 29.82,66.62 66.61,66.62 36.79,0 66.62,-29.82 66.62,-66.62zm-58.3 -35.81l0 28.56 27.76 0 0 14.38 -27.7 0 0 28.3 -15.96 -0 0 -28.36 -27.5 0 0 -14.31 27.5 0 0 -28.56 15.89 0z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc21);
export default __webpack_public_path__ + "static/media/ic_2_1.d0a7cae657c423d31a886b427292bda1.svg";
export { ForwardRef as ReactComponent };